import { memo, useId } from "react";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa";
import { useSelector } from "react-redux";

const TimePickerInput = props => {
    const {
        changeHandler = () => { },
        value: defaultValue,
        label
    } = props;

    const darkMode = useSelector(state => state.theme.darkMode);

    const attrs = {
        disableDayPicker: true,
        value: defaultValue,
        calendar: persian,
        locale: persian_fa,
        calendarPosition: "bottom-right",
        plugins: [<TimePicker hideSeconds />],
        containerClassName: "datepicker-c",
        format: "DD/MM/YY HH:mm",
        onChange: e => {
            changeHandler(`00/00/00 ${e.hour}:${e.minute}`)
        },
        render: (value, openCalendar) => (
            <CustomComponent
                openCalendar={openCalendar}
                value={value}
                label={label}
            />
        ),
    }

    if (darkMode)
        attrs.className = "bg-dark";

    return (
        <DatePicker {...attrs} />
    )
}

const CustomComponent = props => {
    const {
        openCalendar,
        value,
        label
    } = props;

    const id = useId();

    let localValue = "لطفا انتخاب نمایید";
    if (typeof value === "string" && value !== "")
        localValue = value.split(" ")[1];
    else if (typeof value === "object")
        localValue = value[0].split(" ")[1];

    return (
        <div className="text-field relative has-val">
            <label htmlFor={id}>{label}</label>

            <input
                id={id}
                type="text"
                className="block w-full"
                onClick={openCalendar}
                value={localValue}
                onFocus={openCalendar}
                onChange={() => { }}
            />
        </div>
    )
}

export default memo(TimePickerInput);